var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3.5 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 18.8436L12.9509 20.6987L6.42609 32.0001L4.55333 27.8234L9.73779 18.8436Z",
    fill: "#AA75CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 18.8436L6.52467 16.9885L-0.000155079 28.2899L4.55333 27.8234L9.73779 18.8436Z",
    fill: "#73488D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3218 18.8436L11.1087 20.6987L17.6335 32.0001L19.5062 27.8234L14.3218 18.8436Z",
    fill: "#73488D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3218 18.8436L17.5349 16.9885L24.0597 28.2899L19.5062 27.8234L14.3218 18.8436Z",
    fill: "#AA75CB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0246,
    cy: 11.0622,
    r: 11.0622,
    fill: "#DC9E42"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0247,
    cy: 11.0621,
    r: 8.63501,
    fill: "#734C12"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_1242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4857,
    cy: 11.984,
    r: 8.65511,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_1242)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.0247,
    cy: 11.0622,
    r: 8.65511,
    fill: "#A36D1D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0713 5.04102L13.9383 8.77508L17.6724 9.24183L15.1083 12.1171L15.8054 16.2432L12.0713 14.3762L8.33724 16.2432L9.04049 12.1171L6.47021 9.24183L10.2043 8.77508L12.0713 5.04102Z",
    fill: "url(#paint0_linear_103_1242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_1242",
    x1: 12.0713,
    y1: 5.04102,
    x2: 12.0713,
    y2: 16.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FDE870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC759"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/badge1.9d6c84085e7b96cf7432a5954304b841.svg";
export { ForwardRef as ReactComponent };